// extracted by mini-css-extract-plugin
export default {"sliderArrowControl":"sliderArrowControl___qu8ad","sliderArrowControlPrev":"sliderArrowControlPrev___it9UE","sliderArrowControlNext":"sliderArrowControlNext___q123d"};